import {
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { ReadEventClient } from '@internal/plugin-neo4j-techdocs-common';
import { parseEntityRef } from '@backstage/catalog-model';
import { useCallback } from 'react';

type SubmitReadEventResult =
  | { success: true; error?: undefined }
  | { success: false; error: Error };

export const useSubmitReadEvent = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const identityApi = useApi(identityApiRef);
  const readClient = new ReadEventClient({ discoveryApi, fetchApi });

  return useCallback(
    async (
      docEntityRef: string,
      page: string,
    ): Promise<SubmitReadEventResult> => {
      try {
        const identity = await identityApi.getBackstageIdentity();
        const username = parseEntityRef(identity.userEntityRef).name;
        const postPageReadResponse = await readClient.userPost({
          path: { user: username },
          body: {
            docEntityRef,
            page,
          },
        });

        if (!postPageReadResponse.ok) {
          throw new Error(
            `Failed to submit read event: ${postPageReadResponse.statusText}`,
          );
        }

        return { success: true };
      } catch (error) {
        console.error(`Failed to submit read event: ${error}`);
        return { success: false, error: error as Error };
      }
    },
    [discoveryApi, fetchApi, identityApi, readClient],
  );
};
